import React, { useEffect} from 'react';
import { useSelector } from 'react-redux';
import { Card, Form } from '@deere/ux.uxframe-react'
import { getTranslation} from '../utils/utils';
import { EMPTY_BODY } from '../utils/surveyLiterals'
import "../assets/css/Sections.css";

export default function Section({survey, section, review, questionsToValidate, setAnswers, answers}) {
    const surveyResponse = useSelector(state => state.genericSurvey.surveyResponses[survey.code]);
    const questions = section.questions.filter(qu => qu.active).sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1);
        
    useEffect(() => {
         if(surveyResponse && surveyResponse.surveyAnswers){
            if(!review){setAnswers([...surveyResponse.surveyAnswers])}
         }                 
     }, [review, setAnswers, surveyResponse]);


    if (!section)
        return EMPTY_BODY; 

    function findAnswerIndex(questionId, answers){
        return answers ? answers.findIndex(a => parseInt(questionId) === parseInt(a.surveyQuestionId)) : -1;
    }    

    function createOptionSection(data) {
        let indx = findAnswerIndex(data.id, answers);
        let answer = indx>=0? answers[indx].answer : '';
                
        return <Form.Group>
                    <Form.Label id={data.id} className="uxf-label">{getTranslation(data, 'text')}</Form.Label>            
                    {                    
                        <div id={indx}>                        
                            <Form.Label>{answer}</Form.Label>
                        </div>
                    }
                </Form.Group>
    }    

    return (<>
        <Card>
            <Card.Body id={section ? section.description : ''}>
                <Card.Title className='pb-3 font-weight-bold'>
                    {getTranslation(section,'description')}                    
                </Card.Title>                                
                <Card.Subtitle className="mb-4">
                    {getTranslation(section,'longDescription')}
                </Card.Subtitle>                
                <>
                    {
                        <>
                            {            
                                questions.sort((a,b) => (a.showOrder > b.showOrder)? 1 : -1).map((q,index) =>

                                    <div key={index}>
                                        <Form.Row className="d-block mb-4">
                                            {q.type === 'OPTION' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOptionSection(q) : <></>}
                                            {q.type === 'OPEN' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOptionSection(q) : <></>}
                                            {q.type === 'TEXT' && (q.dependentQuestions === 'undefined' || q.dependentQuestions.length <= 0) ? createOptionSection(q) : <></>}
                                        </Form.Row>
                                    </div>
                                )
                            }
                        </>
                    }
                </>
            </Card.Body>
        </Card>        
    </>)
}
